import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Heading } from '@/components/ui/heading';
import ReviewStep from './ReviewStep';
import type { JournalEntry } from '@domain/journal';
import { JOURNAL_STEP_ICONS } from './stepIcons';

export type CompletedStepProps = {
  onReturnHome: () => void;
  entry: JournalEntry;
};

export default function CompletedStep({ onReturnHome, entry }: CompletedStepProps) {
  const StepIcon = JOURNAL_STEP_ICONS.completed;
  return (
    <div className="space-y-6">
      <Card className="p-6 space-y-4 text-center">
        <StepIcon className="mx-auto h-10 w-10 text-primary" />
        <Heading
          level={2}
          align="center"
          description="Ben fatto. Puoi rivedere il diario in qualsiasi momento o aprire una chat se hai bisogno di approfondire."
        >
          Diario completato
        </Heading>
        <div className="flex justify-center gap-3">
          <Button onClick={onReturnHome}>Torna allo storico</Button>
        </div>
      </Card>

      <Card className="p-4">
        <ReviewStep
          entry={entry}
          showActions={false}
          isConfirming={false}
          title="Riepilogo condiviso"
          description="Warm-up, carte selezionate e testo finale inviato."
          emptyLabel="Il riepilogo non è disponibile."
        />
      </Card>
    </div>
  );
}
